const mapElement = document.querySelector(".sr-showroom__map");
const latitude = parseFloat(mapElement.getAttribute("data-lat"));
const longitude = parseFloat(mapElement.getAttribute("data-lng"));

mapboxgl.accessToken =
  "pk.eyJ1IjoiaGFtaWx0b25icm9va2UiLCJhIjoiY20zNXRxODRwMGN2czJqczk1amV2anJxeCJ9.UY50RxSNfz2z29Jgbo93dQ";
const map = new mapboxgl.Map({
  container: mapElement,
  style: "mapbox://styles/mapbox/streets-v11",
  center: [longitude, latitude],
  zoom: 15,
});

const svgMarker = document.createElement("div");
svgMarker.innerHTML = `
  <svg width="42" height="64" viewBox="0 0 42 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.33,64c1.28-21.3,19.67-26.7,19.67-42.7,0-5.9-2.36-11.2-6.2-15.1-3.74-3.8-8.95-6.2-14.75-6.2S10.03,2.4,6.2,6.2C2.36,10.1,0,15.4,0,21.3c0,16,18.39,21.3,19.67,42.7h2.66Z" fill="#004e5f"/><path d="M20.5,26.59c-.32.11-2.37.29-2.71.29-.45,3.63-.77,6.95-.89,9.53,1.31.35,2.68.53,4.13.53,2.32,0,4.55-.5,6.56-1.42-2.26-2.98-4.61-5.98-7.08-8.92M31.92,21.35c-2.05,2.08-4.55,3.53-7.45,4.52,2.4,2.53,4.58,5.05,6.63,7.51,3.6-2.92,5.89-7.4,5.89-12.42,0-2.32-.5-4.55-1.42-6.56-.35,2.68-1.76,5.03-3.66,6.95" fill="#fff"/><path d="M14.39,26.28c.99-5.61,1.16-6.71,2.37-14.21.63-.38,2.14-.95,2.85-.95.35,0,.66.21.66.66,0,.63-.56,3.77-1.06,6.56-.45,2.58-.95,5.19-1.21,7.05,3.66,0,7.34-1.13,10.08-3.5,2.37-2.05,3.77-4.94,3.77-8.15s-1.52-5.85-4.05-7.3c-1.27-.56-2.58-1.02-3.98-1.27-.6-.08-1.21-.11-1.84-.11-3.51.02-6.99,1.18-9.6,3.33-2.53,2.05-4.37,5-4.37,8.74,0,2.89,1.06,6.63,4.08,7.72l-.21.74c-3.45-.08-6.24-2.37-6.81-6.1-.03.5-.08.95-.08,1.45,0,5.95,3.24,11.14,8.08,13.9.26-2.14.74-5.38,1.31-8.56" fill="#fff"/>
  </svg>
`;
svgMarker.style.width = "42px";
svgMarker.style.height = "64px";

new mapboxgl.Marker(svgMarker, { anchor: "bottom" })
  .setLngLat([longitude, latitude])
  .addTo(map);
